const PageTitle = ({ text }) => {
  return (
    <h1 className='py-14 w-full text-4xl text-center font-bold uppercase text-ghostWhite z-10 xl:py-4'>
      {text}
    </h1>
  );
};

export default PageTitle;
